/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weight: NonNullable<unknown> }} Pos_Product_Net_WeightInputs */

const vi_pos_product_net_weight = /** @type {(inputs: Pos_Product_Net_WeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`KL tịnh: ${i?.weight}`)
};

/**

* @param {Pos_Product_Net_WeightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_product_net_weight = /** @type {((inputs: Pos_Product_Net_WeightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Product_Net_WeightInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_product_net_weight(inputs)
});